// extracted by mini-css-extract-plugin
export default {"item":"SkillItem_item__CYjG3","Beginner":"SkillItem_Beginner__bAlG3","Intermediate":"SkillItem_Intermediate__Rupju","Advanced":"SkillItem_Advanced__laLJD"};